import AddIcon from "@mui/icons-material/Add"
import RemoveIcon from "@mui/icons-material/Remove"
import MuiAccordion, { AccordionProps } from "@mui/material/Accordion"
import MuiAccordionDetails from "@mui/material/AccordionDetails"
import MuiAccordionSummary, { AccordionSummaryProps } from "@mui/material/AccordionSummary"
import { styled } from "@mui/material/styles"
import React, { useEffect, useState } from "react"
import { isServer } from "src/utils/utils"

export const Accordion = styled((props: AccordionProps) => {
  const [expanded, setExpanded] = useState(isServer)

  useEffect(() => {
    setExpanded(false)
  }, [])

  return (
    <MuiAccordion
      expanded={expanded}
      onChange={(event, newExpanded) => {
        setExpanded(newExpanded)
      }}
      disableGutters
      elevation={0}
      square
      {...props}
    />
  )
})(({ theme }) => ({
  "&:before": {
    display: "none",
  },
  "&:not(:last-child)": {
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  background: "none",
  border: "none",
  boxShadow: "none",
  margin: 0,
}))

export const AccordionSummary = styled((props: AccordionSummaryProps & { expanded?: boolean }) => {
  const { expanded, ...rest } = props
  return <MuiAccordionSummary expandIcon={expanded ? <RemoveIcon /> : <AddIcon />} {...rest} />
})(({ theme }) => ({
  "& .MuiAccordionSummary-content": {
    fontSize: "1.35rem",
    fontWeight: 700,
    marginLeft: 0,
  },
  "& .MuiAccordionSummary-expandIconWrapper": {
    color: theme.palette.text.primary,
    fontSize: "2rem",
    transition: "transform 0.2s",
  },
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(45deg)",
  },
  padding: theme.spacing(3, 0),
}))

export const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: "1.1rem",
  fontWeight: 400,
  padding: theme.spacing(0, 0, 3, 0),
}))
